import { z } from 'zod'

export const formSchema = z.object({
  date: z.string(),
  studentName: z.string(),
  oen: z.string(),
  year: z.string(),                  // "Year 1" | "Year 2" | ""
  daysAbsent: z.string(),
  totalDaysAbsent: z.string(),
  timesLate: z.string(),
  totalTimesLate: z.string(),
  frenchProgram: z.string(),         // "Immersion" | "Core" | "Extended" | ""
  teacher: z.string(),
  earlyChildhoodEducator: z.string(),
  principal: z.string(),
  telephone: z.string(),
  board: z.string(),
  school: z.string(),
  schoolAddress: z.string(),
  boardAddress: z.string(),
  esl: z.string(),                   // "true" | "false" | "" (stored as string for form-field consistency)
  iep: z.string(),
  keyLearningComments: z.string(),
  boardInformation: z.string(),
  eceNames: z.string(),
  _completedFields: z.array(z.string()).default([]),
})

export const defaultValues = {
  ...Object.fromEntries(
    Object.keys(formSchema.shape)
      .filter((k) => k !== '_completedFields')
      .map((k) => [k, ''])
  ),
  _completedFields: [],
}
